const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div role="alert" className="fixed top-0 left-0 w-full h-full bg-red-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <h2 className="text-2xl font-bold text-red-600">Terjadi Kesalahan</h2>
        <p className="mt-4 text-gray-600">{error.message}</p>
        <button
          onClick={resetErrorBoundary}
          className="mt-6 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Coba Lagi
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;